import { Component, OnInit } from '@angular/core';
import { NgSwitch, NgSwitchCase } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { ItemTabComponent } from '../../_basic/tab-playlist-item.component';
import { PlaylistItemDTO } from '../../../core/models/view-models/playlist-item-models/playlist-item-dto.model';
import { PlaylistItemLinkModel } from '../../../core/models/view-models/playlist-item-models/playlist-item-link.model';
import { PlaylistItemType } from '../../../core/models/enums/playlist-item-type.enum';
import { TabRssTickerComponent } from './tab-rss-ticker/tab-rss-ticker.component';
import { TabTimerComponent } from './tab-timer/tab-timer.component';
import { ForegroundItemType } from '../../../core/enums/foreground-item-type.enum';

@Component({
  selector: 'tab-foreground-item',
  standalone: true,
  imports: [
    FormsModule,
    NgSwitch,
    NgSwitchCase,
    MatIconModule,
    MatButtonToggleModule,
    TabRssTickerComponent,
    TabTimerComponent
  ],
  templateUrl: './tab-foreground-item.component.html',
  styleUrls: [
    './tab-foreground-item.component.scss',
    '../../modal-playlist-item/playlist-item-dialog.component.scss'
  ]
})
export class TabForegroundItemComponent extends ItemTabComponent implements OnInit {
  isRssTabDisabled: boolean;
  isTimerTabDisabled: boolean;
  foregroundTypes = ForegroundItemType;
  selectedType = ForegroundItemType.Rss;

  ngOnInit(): void {
   this.initItem();
  }

  submit() {
    this.playlistItem.PlaylistItemType = PlaylistItemType.Foreground;
    super.saveChanges([this.playlistItem]);
  }

  private initItem() {
    if (this.playlistItem.PlaylistItemType !== PlaylistItemType.Foreground) {
      this.playlistItem = new PlaylistItemDTO();
      this.playlistItem.Duration = null;
      this.playlistItem.PlaylistItemLinks.push(new PlaylistItemLinkModel());
    }

    this.setSelectedTab();
  }

  private setSelectedTab() {
    const playlistHasForegroundRssItem = this.playlist.PlaylistItems.some(item =>
      item.PlaylistItemType === PlaylistItemType.Foreground && item.RssConfigs);
    const playlistHasForegroundTimerItem = this.playlist.PlaylistItems.some(item =>
      item.PlaylistItemType === PlaylistItemType.Foreground && item.TimerConfig)

    if (this.playlistItem.RssConfigs) {
      this.selectedType = this.foregroundTypes.Rss;
    }
    else if (this.playlistItem.TimerConfig || playlistHasForegroundRssItem) {
      this.selectedType = this.foregroundTypes.ClockTimer;
    }

    this.isRssTabDisabled = this.selectedType !== this.foregroundTypes.Rss && playlistHasForegroundRssItem;
    this.isTimerTabDisabled = this.selectedType !== this.foregroundTypes.ClockTimer && playlistHasForegroundTimerItem;
  }
}
